<template>
  <div id="app">
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link :to="{name: 'index'}" class="navbar-item">
          <img src="@/assets/logo.png" width="112" height="28"/>
        </router-link>
        <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        </a>
      </div>
      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <router-link :to="{name: 'index'}" class="navbar-item">
          Главная
          </router-link>
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons" v-if="!isAuthenticatedUser">
              <router-link :to="{name: 'login'}" class="button is-light">
                Вход
              </router-link>
            </div>
            <div class="buttons" v-if="isAuthenticatedUser">
              <a class="button is-light" :disabled="true">
                @{{getUser.username}}
              </a>
              <router-link :to="{name: 'logout'}" class="button is-primary">
                <strong>Выход</strong>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <section class="section mt-4" id="body">
      <component :is="layout">
        <router-view/>
      </component>
    </section>
    <footer class="footer">
      <div class="content has-text-left">
        <!-- <p>
          <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p> -->
      </div>
    </footer>
  </div>
</template>

<script>
const default_layout = 'ui-admin';
import {
  EventBus
} from '@/utils'
export default {
  name: 'App',
  components: {
    //
  },
  data() {
    return {
      //
    }
  },
  created () {
    EventBus.$on("logout", (command) => {
      this.$store.dispatch('logout')
      this.$router.push("/logout").catch(() => {});
    })
  },
  beforeDestroy() {
    EventBus.$off('logout')
  },
  mounted(){
    //
  },
  computed: {
    layout() {
      return  "lay-" + (this.$route.meta.layout || default_layout)
    },
    isAuthenticatedUser(){
      return this.$store.getters.isAuthenticatedUser
    },
    getUser(){
      return this.$store.getters.getUser 
    }
  },
  methods: {
    //
  }
}
</script>

<style>
  #app {
    /*text-align: center;*/
  }
  .navbar {
    box-shadow: 0 8px 8px rgb(10 10 10 / 10%);
  }
  #body {
    max-height: 100%;
  }
</style>
